module.exports = __webpack_public_path__ + "img/gift4-01-c01-y1.461f6726.png";